<section class="category-section">
  <div class="container">
    <div class="category-header">
      <span class="category-label">Browse by Category</span>
      <h2 class="category-title">Our Categories</h2>
    </div>

    <div class="category-scroll-wrapper">
      <div class="category-scroll-container">
        <button
          *ngFor="let cat of projectCategories"
          class="cat-card"
          (click)="navigateToCategory(cat.id)">
          <img *ngIf="cat.image" [src]="cat.image" [alt]="cat.name" class="cat-image" (error)="$event.target.src='assets/img/whiteimage.jpg'">
          <span class="cat-name">{{ cat.name }}</span>
        </button>
      </div>
    </div>
  </div>
</section>
